import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AppRoutes } from '@app/utils/enums/routes.enum';

@Component({
  selector: 'app-forgot-password-success',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './forgot-password-success.component.html',
  styleUrl: './forgot-password-success.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForgotPasswordSuccessComponent {
  public readonly email = input<string>();
  public readonly appRoutes = AppRoutes;
  private readonly router = inject(Router);

  public returnToLogin(): void {
    this.router.navigate([this.appRoutes.LOGIN]);
  }
}
